/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleSubmissionResponse } from './moduleSubmissionResponse';

export type GenericApiResponseModuleSubmissionResponseData = ModuleSubmissionResponse | null;
